var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"d-flex p-3 align-items-center justify-content-center",staticStyle:{"width":"100%","height":"100%","flex-direction":"column","background-color":"#1C1B1B !important","border-radius":"10px"}},[_c('div',{staticClass:"chart-container mb-4",staticStyle:{"position":"relative"}},[_c('canvas',{attrs:{"id":_vm.dataKey}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }